module.exports = __webpack_public_path__ + "static/montserrat-latin-300-7c3daf12b706645b5d3710f863a4da04.woff2";